export default __webpack_public_path__ + "static/cp-hero-9353f1af243ff33ad5c893e85f523546.webm";